import { IconType } from './types';

export const BurgerIcon = ({ size = 24, color = 'black' }: IconType) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 24 24">
    <path stroke={color} strokeLinecap="round" strokeWidth={2} d="M5 12h15M5 17h15M5 7h15" />
  </svg>
);
